// use this entry point to export your modules
export {default as HelloWorld} from './HelloWorld';


/** WEBPACK FOOTER **
 ** ../~/eslint-loader!../src/index.js
 **/